module.exports = __webpack_public_path__ + "media/icons/filter-36b37610.svg";